import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils"

// Revenuewise Button: one blue action color, radius-md, sizes sm 32 / md 36 / lg 44.
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "border-blue-600 bg-blue-600 text-white hover:border-blue-700 hover:bg-blue-700",
        primary: "border-blue-600 bg-blue-600 text-white hover:border-blue-700 hover:bg-blue-700",
        fitness: "border-blue-600 bg-blue-600 text-white hover:border-blue-700 hover:bg-blue-700",
        destructive: "border-red-300 bg-white text-red-600 hover:bg-red-50",
        outline: "border-slate-300 bg-white text-slate-900 hover:border-slate-400 hover:bg-slate-50",
        secondary: "border-slate-300 bg-white text-slate-900 hover:border-slate-400 hover:bg-slate-50",
        ghost: "border-transparent bg-transparent text-slate-700 hover:bg-slate-100",
        link: "border-transparent text-blue-700 underline-offset-4 hover:underline",
        success: "border-emerald-700 bg-emerald-700 text-white hover:bg-emerald-800",
        warning: "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100",
        // The chosen option in a set of toggle buttons (not an action).
        selected: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100",
      },
      size: {
        default: "h-9 px-4 text-sm",
        sm: "h-8 px-3 text-xs",
        lg: "h-11 px-6 text-sm",
        xl: "h-11 px-6 text-sm",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
